module.exports = __webpack_public_path__ + "media/images/countryrect/pa-ab9df8d26b483d37ec198a0f0724a695.svg";